module.exports = {
	"arrow-down": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M12,2v20 M2,12.1l10,9.7l10-9.7"
			}
		]
	},
	"arrow-left": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M11.9,22L2.1,12l9.7-10 M2,12h20"
			}
		]
	},
	"arrow-right": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M22,12H2 M12.1,2l9.7,10l-9.7,10"
			}
		]
	},
	"arrow-up": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M2,11.7L12,2l10,9.7 M12,2v20"
			}
		]
	},
	"calendar": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M21.5 21.5h-19v-19h19v19zM2.5 5h19"
			},
			{
				"d": "M6.29 11.55h1.43a2.32 2.32 0 01.11-.87 2.08 2.08 0 012.53-1 1.49 1.49 0 011.22 1.39 1.26 1.26 0 01-.76.93 6.08 6.08 0 01-2 .36v1.42h.68a4.39 4.39 0 011.64.28 1.46 1.46 0 01.12 2.65 2.84 2.84 0 01-2.67.14 2.46 2.46 0 01-1-2.13H6.16a3.71 3.71 0 001.78 3.38 4 4 0 001.85.45 4.28 4.28 0 002.21-.64 3 3 0 001.44-2.75A2.83 2.83 0 0012 12.9a2.49 2.49 0 001-1.76 2.85 2.85 0 00-2.26-2.82 3.38 3.38 0 00-1.08-.17 3.49 3.49 0 00-3.16 2 3.34 3.34 0 00-.21 1.4zM16.32 8.46a1.85 1.85 0 01-.46 1.33 2.08 2.08 0 01-1.25.47h-.17v1.43h1.88v6.49h1.43V8.46z"
			}
		]
	},
	"caret-down": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M22,7L12,17L2,7"
			}
		]
	},
	"caret-left": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M17,22L7,12L17,2"
			}
		]
	},
	"caret-right": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M7,2l10,10L7,22"
			}
		]
	},
	"caret-up": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M2,17L12,7l10,10"
			}
		]
	},
	"checkmark": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M22,3.7L8.8,19.6l-6.8-8"
			}
		]
	},
	"close": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M2,2l20,20"
			},
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M2,22L22,2"
			}
		]
	},
	"collapse": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M2,12h20"
			}
		]
	},
	"error": {
		"viewBox": "0 0 24 24",
		"paths": [],
		"rect": [
			{
				"x": "11",
				"y": "16.03",
				"width": "2",
				"height": "1.98"
			},
			{
				"vector-effect": "non-scaling-stroke",
				"x": "4.34",
				"y": "4.34",
				"width": "15.31",
				"height": "15.31",
				"rx": "2",
				"transform": "translate(-4.97 12) rotate(-45)"
			}
		],
		"polygon": [
			{
				"points": "12.33 14.04 11.66 14.04 11 10.94 11 7.02 12.99 7.02 12.99 10.94 12.33 14.04"
			}
		]
	},
	"expand": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M12,2v20"
			},
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M2,12h20"
			}
		]
	},
	"info": {
		"viewBox": "0 0 24 24",
		"paths": [],
		"circle": [
			{
				"vector-effect": "non-scaling-stroke",
				"cx": "12",
				"cy": "12",
				"r": "10"
			}
		],
		"rect": [
			{
				"x": "10.99",
				"y": "9.98",
				"width": "2.02",
				"height": "8"
			},
			{
				"x": "10.98",
				"y": "6",
				"width": "2",
				"height": "2"
			}
		]
	},
	"success": {
		"viewBox": "0 0 24 24",
		"paths": [],
		"circle": [
			{
				"vector-effect": "non-scaling-stroke",
				"cx": "12",
				"cy": "12",
				"r": "10"
			}
		],
		"polyline": [
			{
				"vector-effect": "non-scaling-stroke",
				"points": "7.32 12 10 14.67 15.86 8.79"
			}
		]
	},
	"warning": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"vector-effect": "non-scaling-stroke",
				"d": "M13.54,3.93l8.22,14.26a1.79,1.79,0,0,1-1.55,2.68H3.79a1.79,1.79,0,0,1-1.55-2.68L10.45,3.93A1.78,1.78,0,0,1,13.54,3.93Z"
			}
		],
		"rect": [
			{
				"x": "11",
				"y": "16",
				"width": "2",
				"height": "1.98"
			}
		],
		"polygon": [
			{
				"points": "12.33 14.01 11.66 14.01 11 10.91 11 7.98 13 7.98 13 10.91 12.33 14.01"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@vds/icons/dist/cjs/Icon/data.json
// module id = 638
// module chunks = 0